module.exports = __webpack_public_path__ + "img/appoint_pc.772119e1.png";